module.exports = __webpack_public_path__ + "img/beer_id-3.a46d0684.png";